<template lang="pug">
    v-card
        model-data-table( 
            :headers="headers"
            :filters="filters"
            :service="service"
            :no-detail="! $can('VIEW_DETAIL_ABSENCE_REQUEST')"
            no-filter
            :no-remove="! $can('DELETE_ABSENCE_REQUEST')"
            param-search="comment"
            ref="refDTAbsenceRequestList"
            remind-key='absence-request-list'
            @remove="submitDeleteAbsenceRequest($event.item.id)"
            @detail="showAbsenceRequest($event.item)"
        )
            template( slot='actions' slot-scope='props' )
                r-btn-action(
                    color='success'
                    :disabled='! props.item.can_holiday_pdf'
                    tooltip='Descargar'
                    @click='props.item.toHolidayPdf()' 
                )
                    v-icon cloud_download
        crud-create-button(
            :action="() => $router.push('/absence_request/create')"
            text="Crear Solicitud"
            v-if="$can('CREATE_ABSENCE_REQUEST')"
            )
        dialog-absence-request-details(
            ref="refDialogAbsenceRequestDetails"
            :absenceRequestObj="absenceRequestObj"
            @success="refreshDataTable"
            )
</template>

<script>
//-
import { mapActions, mapState } from 'vuex'
import {
    CrudCreateButton,
    CrudDataTable,
    DTService,
} from '@/components/reusable_components'
import HeadersAbsenceRequest from './HeadersAbsenceRequest'
import AbsenceRequestIncludes from '@/services/api/absenceRequest/AbsenceRequestIncludes'
import { deleteAbsenceRequest } from '@/services/api/absenceRequest'
import DialogAbsenceRequestDetails from './partials/DialogAbsenceRequest'
//
import { RBtnAction, ModelDataTable } from '@/components/reusable_components/next'
import AbsenceRequestModel from '@/models/HumanResource/HrAbsenceRequest'
//-
export default {
    name: 'absence-request-list',
    // props: {},
    data: function() {
        return {
            headers: HeadersAbsenceRequest,
            filters: [],
            service: AbsenceRequestModel,
            deleteId: 0,
            absenceRequestObj: {},
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        getAbsenceRequest: function() {
            const url = process.env.VUE_APP_API_ROUTE.concat(
                `/hr_absence_request`
            )
            this.service.dtFetchData = DTService.getFetchDataFunction(
                url,
                AbsenceRequestIncludes,
                []
            )
        },
        // -- Data handling and transformations
        showAbsenceRequest: function(item) {
            this.absenceRequestObj = item
            this.$refs.refDialogAbsenceRequestDetails.open = true
        },
        submitDeleteAbsenceRequest: function(id) {
            //-
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Eliminar')
            //-
            let payload = this.fillSnack(
                'warning',
                '¿Desea eliminar solicitud de ausencia?',
                ''
            )
            this.initSnackbar(payload)
            //-
            this.deleteId = id
        },
        // -- Validations and Error handling
        refreshDataTable: function() {
            this.$refs.refDTAbsenceRequestList.refresh()
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Eliminar') {
                this.resetSnackbarState()
                let response = await deleteAbsenceRequest(this.deleteId)
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Solicitud de ausencia eliminada',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTAbsenceRequestList.checkAndFetch()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-data-table': CrudDataTable,
        'crud-create-button': CrudCreateButton,
        'dialog-absence-request-details': DialogAbsenceRequestDetails,
        ModelDataTable,
        RBtnAction,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    mounted: function() {
        this.setTitleTopBar('Solicitudes de ausencia')
        this.getAbsenceRequest()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_ABSENCE_REQUEST')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>